import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ListItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { ClientIcon } from '~/modules/common/components/Icons';

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(1),
    fontSize: theme.typography.body2.fontSize
  }
}));

const useListItemStyles = makeStyles(() => ({
  root: {
    padding: 0
  }
}));

export const ClientItem = ({ value }) => {
  const classes = useStyles();
  const listItemClasses = useListItemStyles();

  const labelStyle = useMemo(() => ({ root: classes.root }), [classes.root]);

  return (
    <ListItem component="div" classes={listItemClasses}>
      <>
        <ClientIcon />
        <Typography variant="inherit" classes={labelStyle} color="inherit">
          {value}
        </Typography>
      </>
    </ListItem>
  );
};

ClientItem.propTypes = {
  value: PropTypes.string
};

export default ClientItem;
